<script setup lang="ts">
import moment from "moment";
import { ref, onMounted, onUnmounted } from "vue";

const isBreakActive = ref(false);
const sessionTime = ref(0);
const sessionTimeText = ref("");
let interval: NodeJS.Timeout | null = null;

onMounted(() => {
  interval = setInterval(() => {
    if (typeof window.getCurrentShiftDuration === "function") {
      window.getCurrentShiftDuration().then((duration) => {
        sessionTime.value = duration;
        const durationMoment = moment.duration(duration, "seconds");
        sessionTimeText.value = `${durationMoment.hours()}h ${durationMoment.minutes()}m`;
      });
    }
  }, 1000);
});

onUnmounted(() => {
  clearInterval(interval!);
});

const startBreak = () => {
  isBreakActive.value = true;
  if (typeof window.triggerPause === "function") {
    window.triggerPause();
  }
};
</script>

<template>
  <div class="break-time">
    <div :class="{ started: sessionTime > 0 }" class="pause-button-container" @click="startBreak">
      <i class="fa fa-pause"></i>
    </div>
    <div v-if="sessionTime > 0" class="duration">{{ sessionTimeText }}</div>
  </div>
</template>

<style scoped>
.break-time {
  position: relative;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
}

.pause-button-container {
  margin-top: -3px;
  width: 36px;
  height: 36px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s;
}

.pause-button-container.started {
  width: 26px;
  height: 26px;
}

.pause-button-container:hover {
  background-color: rgba(0, 0, 0, 0.4);
}

.pause-button-container i {
  color: white;
  font-size: 16px;
}

.pause-button-container.started i {
  font-size: 12px;
}

.duration {
  font-size: 10px;
  color: white;
  font-weight: bold;
}
</style>
